import React, { FC, useEffect } from "react";
import countdown from "assets/gifs/countdown.gif";
import { useNavigate } from "react-router-dom";
import { ALL_POLICY_TYPES } from "utils/utils";

interface ResultCountDownProps {
  policyId: string;
  policyTypeId: string;
}

const ResultCountDown: FC<ResultCountDownProps> = ({ policyId, policyTypeId }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (policyTypeId === ALL_POLICY_TYPES.HEALTH) navigate(`/kyp/benefit-summary/${policyId}`);
      else navigate(`/kyp/motor-benefit-summary/${policyId}`);
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate, policyId]);
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-start z-50 bg-black bg-opacity-80 pt-40">
      <div className="bg-overlay-gradient border-4 rounded-[10px]  p-5 flex flex-col items-center justify-center gap-5 mx-2">
        <p className="font-extrabold md:text-2xl text-xl w-full md:w-[70%] text-center">KYP results are now Available</p>
        <img src={countdown} className="w-20 h-20 rounded-full" />
      </div>
    </div>
  );
};

export default ResultCountDown;
